import { useEffect, useState } from "react";
import "./AllProjects.scss";
import ProjectCard from "./ProjectCard";

const RenderProjectShowCase = () => {
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        setProjects([
            {
                imageSrc:
                    'https://img.freepik.com/free-vector/application-learn-languages_23-2148624202.jpg?w=826&t=st=1706246241~exp=1706246841~hmac=7a150592f1bc3d4576b51948e96bf36baeeb60f4d1907294f5e093b126c4437f',
                projectName: 'EduMetrics Pro',
                projectDomain: 'Flutter App',
                dataOfCompletion: '31/1/2024',
                projectShortDescription: 'A classroom manager mobile application',
            },
            {
                imageSrc:
                    'https://img.freepik.com/free-psd/digital-marketing-landing-page-template_23-2148924857.jpg?w=900&t=st=1706260411~exp=1706261011~hmac=72038f30c44349b0f8a2dad71ac81b82647e7f080e70a3a63c6cd785f2fdcefb',
                projectName: 'Project Hub',
                projectDomain: 'Web App',
                dataOfCompletion: '5/2/2024',
                projectShortDescription: 'A website to support student and developers',
            },
            {
                imageSrc:
                    'https://img.freepik.com/free-vector/space-explorer-landing-page-template_107791-16255.jpg?w=740&t=st=1706260494~exp=1706261094~hmac=6514cf89f1193473d4e88c72012d3acbe65df967b9d146b53463676b583f2a4e',
                projectName: 'Space Shooter',
                projectDomain: 'Game Application',
                dataOfCompletion: '12/12/2022',
                projectShortDescription: 'A game in which the user destroys enemy ships',
            },
            {
                imageSrc:
                    'https://img.freepik.com/free-vector/application-learn-languages_23-2148624202.jpg?w=826&t=st=1706246241~exp=1706246841~hmac=7a150592f1bc3d4576b51948e96bf36baeeb60f4d1907294f5e093b126c4437f',
                projectName: 'EduMetrics Pro',
                projectDomain: 'Flutter App',
                dataOfCompletion: '31/1/2024',
                projectShortDescription: 'A classroom manager mobile application',
            },
            {
                imageSrc:
                    'https://img.freepik.com/free-psd/digital-marketing-landing-page-template_23-2148924857.jpg?w=900&t=st=1706260411~exp=1706261011~hmac=72038f30c44349b0f8a2dad71ac81b82647e7f080e70a3a63c6cd785f2fdcefb',
                projectName: 'Project Hub',
                projectDomain: 'Web App',
                dataOfCompletion: '5/2/2024',
                projectShortDescription: 'A website to support student and developers',
            },
            {
                imageSrc:
                    'https://img.freepik.com/free-vector/space-explorer-landing-page-template_107791-16255.jpg?w=740&t=st=1706260494~exp=1706261094~hmac=6514cf89f1193473d4e88c72012d3acbe65df967b9d146b53463676b583f2a4e',
                projectName: 'Space Shooter',
                projectDomain: 'Game Application',
                dataOfCompletion: '12/12/2022',
                projectShortDescription: 'A game in which the user destroys enemy ships',
            },
        ])
    }, []);

    return <section className="all-projects__section">
        {/* <h1>Explore My All Time Works</h1> */}
        <div className="all-projects__container">
            {projects.map((e) => <ProjectCard {...e} key={e.index} />)}
        </div>
    </section>
}


export default RenderProjectShowCase;